export const servicesList = [
  {
    id: 'walking',
    title: 'Walking Services',
    subtitle: 'Urban Routes, Curated Energy',
    description: 'Beyond the block. We curate urban adventures through riverside trails and green corridors, matching your dog\u2019s spirit with a dedicated expert. Every session is tracked via GPS with real-time photo updates for your total peace of mind.',
    features: [
      'GPS-tracked routes with real-time updates',
      'Group or solo walks available',
      'Rain or shine, we show up',
      'Trained in urban safety protocols',
    ],
    price: 'From $15 / walk',
    duration: '30 or 60 minutes',
    image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/b5b15d5baa59ec4dcbc558ab102370b3.jpeg',
    accent: 'forest',
  },
  {
    id: 'sitting',
    title: 'Home Sitting',
    subtitle: 'Your Home, Their Comfort',
    description: 'Your pet stays in their familiar environment while receiving round-the-clock care. Our sitters are trained in medication administration, emergency protocols, and maintaining your pet\'s daily routine. You receive daily photo updates and detailed care logs.',
    features: [
      '24/7 in-home care and companionship',
      'Medication administration certified',
      'Daily photo updates and care logs',
      'House-sitting duties included',
    ],
    price: 'From $65 / day',
    duration: 'Overnight or extended stays',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20interior%20scene%20with%20a%20golden%20retriever%20relaxing%20on%20a%20modern%20sofa%20in%20a%20sunlit%20living%20room%20warm%20earthy%20tones%20cream%20walls%20natural%20wood%20furniture%20editorial%20lifestyle%20photography%20soft%20natural%20light%20high%20quality%20professional%20photography&width=800&height=600&seq=21&orientation=landscape',
    accent: 'sienna',
  },
  {
    id: 'training',
    title: 'Behavior Training',
    subtitle: 'Positive Reinforcement, Lasting Bonds',
    description: 'Our certified trainers use science-backed positive reinforcement methods. From puppy socialization to advanced obedience and behavioral modification, we build confidence in your dog and strengthen your relationship.',
    features: [
      'Certified positive reinforcement trainers',
      'Puppy basics to advanced obedience',
      'Behavioral modification programs',
      'In-home or facility sessions',
    ],
    price: 'From $50 / session',
    duration: '45 or 90 minutes',
    image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/957a430bc0a414e9dabae0e261337466.webp',
    accent: 'forest',
  },
  {
    id: 'grooming',
    title: 'Grooming Studio',
    subtitle: 'Boutique Care, Premium Products',
    description: 'Our grooming studio offers a spa-like experience with premium, hypoallergenic products. Every session includes a bath, cut, nail care, ear cleaning, and styling. We finish with a complimentary bandana or bow.',
    features: [
      'Premium hypoallergenic products',
      'Bath, cut, nail care, ear cleaning',
      'Styling and breed-specific cuts',
      'Complimentary bandana or bow',
    ],
    price: 'From $35 / session',
    duration: '60 to 120 minutes',
    image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/6c81b3bdb0be663780da6c1205e96687.png',
    accent: 'sienna',
  },
];

export const servicePackages = [
  {
    name: 'Essential',
    description: 'Perfect for occasional needs',
    price: '$120',
    period: '/ month',
    features: [
      '4 walks per month',
      '1 grooming session',
      'Email support',
      'Basic care reports',
    ],
  },
  {
    name: 'Premium',
    description: 'For the dedicated pet parent',
    price: '$280',
    period: '/ month',
    features: [
      '12 walks per month',
      '2 grooming sessions',
      'Priority scheduling',
      'Detailed care reports',
      '1 training session',
    ],
    highlighted: true,
  },
  {
    name: 'Complete',
    description: 'Full-spectrum care package',
    price: '$450',
    period: '/ month',
    features: [
      'Unlimited walks',
      '4 grooming sessions',
      '2 training sessions',
      '24/7 priority support',
      'Home sitting (2 nights)',
    ],
  },
];